export class StartupConfig
{
    defaultLanguage:string = "de";
    idsUrl:string = "";
    clientId:string = "";
    clientScopes:string = "";
    ssoType:number = 1;


    constructor(idsUrl:string, clientId:string, scopes:string, ssoType:number) {
        this.idsUrl = idsUrl
        this.clientId = clientId
        this.clientScopes = scopes
        this.ssoType = ssoType;
    }
}